(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7198],{

/***/ 2711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():0}(this,function(){"use strict";var e="undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{},t="Expected a function",n=NaN,o="[object Symbol]",i=/^\s+|\s+$/g,a=/^[-+]0x[0-9a-f]+$/i,r=/^0b[01]+$/i,c=/^0o[0-7]+$/i,s=parseInt,u="object"==typeof e&&e&&e.Object===Object&&e,d="object"==typeof self&&self&&self.Object===Object&&self,l=u||d||Function("return this")(),f=Object.prototype.toString,m=Math.max,p=Math.min,b=function(){return l.Date.now()};function v(e,n,o){var i,a,r,c,s,u,d=0,l=!1,f=!1,v=!0;if("function"!=typeof e)throw new TypeError(t);function y(t){var n=i,o=a;return i=a=void 0,d=t,c=e.apply(o,n)}function h(e){var t=e-u;return void 0===u||t>=n||t<0||f&&e-d>=r}function k(){var e=b();if(h(e))return x(e);s=setTimeout(k,function(e){var t=n-(e-u);return f?p(t,r-(e-d)):t}(e))}function x(e){return s=void 0,v&&i?y(e):(i=a=void 0,c)}function O(){var e=b(),t=h(e);if(i=arguments,a=this,u=e,t){if(void 0===s)return function(e){return d=e,s=setTimeout(k,n),l?y(e):c}(u);if(f)return s=setTimeout(k,n),y(u)}return void 0===s&&(s=setTimeout(k,n)),c}return n=w(n)||0,g(o)&&(l=!!o.leading,r=(f="maxWait"in o)?m(w(o.maxWait)||0,n):r,v="trailing"in o?!!o.trailing:v),O.cancel=function(){void 0!==s&&clearTimeout(s),d=0,i=u=a=s=void 0},O.flush=function(){return void 0===s?c:x(b())},O}function g(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function w(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&f.call(e)==o}(e))return n;if(g(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=g(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(i,"");var u=r.test(e);return u||c.test(e)?s(e.slice(2),u?2:8):a.test(e)?n:+e}var y=function(e,n,o){var i=!0,a=!0;if("function"!=typeof e)throw new TypeError(t);return g(o)&&(i="leading"in o?!!o.leading:i,a="trailing"in o?!!o.trailing:a),v(e,n,{leading:i,maxWait:n,trailing:a})},h="Expected a function",k=NaN,x="[object Symbol]",O=/^\s+|\s+$/g,j=/^[-+]0x[0-9a-f]+$/i,E=/^0b[01]+$/i,N=/^0o[0-7]+$/i,z=parseInt,C="object"==typeof e&&e&&e.Object===Object&&e,A="object"==typeof self&&self&&self.Object===Object&&self,q=C||A||Function("return this")(),L=Object.prototype.toString,T=Math.max,M=Math.min,S=function(){return q.Date.now()};function D(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function H(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&L.call(e)==x}(e))return k;if(D(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=D(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(O,"");var n=E.test(e);return n||N.test(e)?z(e.slice(2),n?2:8):j.test(e)?k:+e}var $=function(e,t,n){var o,i,a,r,c,s,u=0,d=!1,l=!1,f=!0;if("function"!=typeof e)throw new TypeError(h);function m(t){var n=o,a=i;return o=i=void 0,u=t,r=e.apply(a,n)}function p(e){var n=e-s;return void 0===s||n>=t||n<0||l&&e-u>=a}function b(){var e=S();if(p(e))return v(e);c=setTimeout(b,function(e){var n=t-(e-s);return l?M(n,a-(e-u)):n}(e))}function v(e){return c=void 0,f&&o?m(e):(o=i=void 0,r)}function g(){var e=S(),n=p(e);if(o=arguments,i=this,s=e,n){if(void 0===c)return function(e){return u=e,c=setTimeout(b,t),d?m(e):r}(s);if(l)return c=setTimeout(b,t),m(s)}return void 0===c&&(c=setTimeout(b,t)),r}return t=H(t)||0,D(n)&&(d=!!n.leading,a=(l="maxWait"in n)?T(H(n.maxWait)||0,t):a,f="trailing"in n?!!n.trailing:f),g.cancel=function(){void 0!==c&&clearTimeout(c),u=0,o=s=i=c=void 0},g.flush=function(){return void 0===c?r:v(S())},g},W=function(){};function P(e){e&&e.forEach(function(e){var t=Array.prototype.slice.call(e.addedNodes),n=Array.prototype.slice.call(e.removedNodes);if(function e(t){var n=void 0,o=void 0;for(n=0;n<t.length;n+=1){if((o=t[n]).dataset&&o.dataset.aos)return!0;if(o.children&&e(o.children))return!0}return!1}(t.concat(n)))return W()})}function Y(){return window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver}var _={isSupported:function(){return!!Y()},ready:function(e,t){var n=window.document,o=new(Y())(P);W=t,o.observe(n.documentElement,{childList:!0,subtree:!0,removedNodes:!0})}},B=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},F=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),I=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},K=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,G=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,J=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,Q=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;function R(){return navigator.userAgent||navigator.vendor||window.opera||""}var U=new(function(){function e(){B(this,e)}return F(e,[{key:"phone",value:function(){var e=R();return!(!K.test(e)&&!G.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=R();return!(!J.test(e)&&!Q.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}},{key:"ie11",value:function(){return"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style}}]),e}()),V=function(e,t){var n=void 0;return U.ie11()?(n=document.createEvent("CustomEvent")).initCustomEvent(e,!0,!0,{detail:t}):n=new CustomEvent(e,{detail:t}),document.dispatchEvent(n)},X=function(e){return e.forEach(function(e,t){return function(e,t){var n=e.options,o=e.position,i=e.node,a=(e.data,function(){e.animated&&(function(e,t){t&&t.forEach(function(t){return e.classList.remove(t)})}(i,n.animatedClassNames),V("aos:out",i),e.options.id&&V("aos:in:"+e.options.id,i),e.animated=!1)});n.mirror&&t>=o.out&&!n.once?a():t>=o.in?e.animated||(function(e,t){t&&t.forEach(function(t){return e.classList.add(t)})}(i,n.animatedClassNames),V("aos:in",i),e.options.id&&V("aos:in:"+e.options.id,i),e.animated=!0):e.animated&&!n.once&&a()}(e,window.pageYOffset)})},Z=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}},ee=function(e,t,n){var o=e.getAttribute("data-aos-"+t);if(void 0!==o){if("true"===o)return!0;if("false"===o)return!1}return o||n},te=function(e,t){return e.forEach(function(e,n){var o=ee(e.node,"mirror",t.mirror),i=ee(e.node,"once",t.once),a=ee(e.node,"id"),r=t.useClassNames&&e.node.getAttribute("data-aos"),c=[t.animatedClassName].concat(r?r.split(" "):[]).filter(function(e){return"string"==typeof e});t.initClassName&&e.node.classList.add(t.initClassName),e.position={in:function(e,t,n){var o=window.innerHeight,i=ee(e,"anchor"),a=ee(e,"anchor-placement"),r=Number(ee(e,"offset",a?0:t)),c=a||n,s=e;i&&document.querySelectorAll(i)&&(s=document.querySelectorAll(i)[0]);var u=Z(s).top-o;switch(c){case"top-bottom":break;case"center-bottom":u+=s.offsetHeight/2;break;case"bottom-bottom":u+=s.offsetHeight;break;case"top-center":u+=o/2;break;case"center-center":u+=o/2+s.offsetHeight/2;break;case"bottom-center":u+=o/2+s.offsetHeight;break;case"top-top":u+=o;break;case"bottom-top":u+=o+s.offsetHeight;break;case"center-top":u+=o+s.offsetHeight/2}return u+r}(e.node,t.offset,t.anchorPlacement),out:o&&function(e,t){window.innerHeight;var n=ee(e,"anchor"),o=ee(e,"offset",t),i=e;return n&&document.querySelectorAll(n)&&(i=document.querySelectorAll(n)[0]),Z(i).top+i.offsetHeight-o}(e.node,t.offset)},e.options={once:i,mirror:o,animatedClassNames:c,id:a}}),e},ne=function(){var e=document.querySelectorAll("[data-aos]");return Array.prototype.map.call(e,function(e){return{node:e}})},oe=[],ie=!1,ae={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,mirror:!1,anchorPlacement:"top-bottom",startEvent:"DOMContentLoaded",animatedClassName:"aos-animate",initClassName:"aos-init",useClassNames:!1,disableMutationObserver:!1,throttleDelay:99,debounceDelay:50},re=function(){return document.all&&!window.atob},ce=function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&(ie=!0),ie&&(oe=te(oe,ae),X(oe),window.addEventListener("scroll",y(function(){X(oe,ae.once)},ae.throttleDelay)))},se=function(){if(oe=ne(),de(ae.disable)||re())return ue();ce()},ue=function(){oe.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay"),ae.initClassName&&e.node.classList.remove(ae.initClassName),ae.animatedClassName&&e.node.classList.remove(ae.animatedClassName)})},de=function(e){return!0===e||"mobile"===e&&U.mobile()||"phone"===e&&U.phone()||"tablet"===e&&U.tablet()||"function"==typeof e&&!0===e()};return{init:function(e){return ae=I(ae,e),oe=ne(),ae.disableMutationObserver||_.isSupported()||(console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '),ae.disableMutationObserver=!0),ae.disableMutationObserver||_.ready("[data-aos]",se),de(ae.disable)||re()?ue():(document.querySelector("body").setAttribute("data-aos-easing",ae.easing),document.querySelector("body").setAttribute("data-aos-duration",ae.duration),document.querySelector("body").setAttribute("data-aos-delay",ae.delay),-1===["DOMContentLoaded","load"].indexOf(ae.startEvent)?document.addEventListener(ae.startEvent,function(){ce(!0)}):window.addEventListener("load",function(){ce(!0)}),"DOMContentLoaded"===ae.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1&&ce(!0),window.addEventListener("resize",$(ce,ae.debounceDelay,!0)),window.addEventListener("orientationchange",$(ce,ae.debounceDelay,!0)),oe)},refresh:ce,refreshHard:se}});


/***/ }),

/***/ 40237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bv": function() { return /* binding */ FilterDrawerMobileCta; },
/* harmony export */   "E": function() { return /* binding */ ListingHeading; },
/* harmony export */   "GW": function() { return /* binding */ PromoSliderContainer; },
/* harmony export */   "Ne": function() { return /* binding */ AdWidgetContainer; },
/* harmony export */   "UT": function() { return /* binding */ FilterDrawerMobileCtaContainer; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "Y$": function() { return /* binding */ FilterDrawerWrapper; },
/* harmony export */   "ef": function() { return /* binding */ FilterDrawerMobileCtaApply; }
/* harmony export */ });
/* unused harmony export Listing */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80344);
/* harmony import */ var _utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13508);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13886);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  width: 90%;\n  max-width: 1600px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  box-sizing: border-box;\n  @media screen and (max-width: 767px) {\n    padding-top: 0;\n    width: 100vw;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  width: 100%;\n  font-size: 40px;\n  color: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 40px;\n    margin-bottom: 3rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 28px;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1000px;\n  display: grid;\n  grid-template-rows: auto;\n  justify-items: center;\n  box-sizing: border-box;\n\n  @media screen and (min-width: 767px) {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    row-gap: 2rem;\n    column-gap: 1.5rem;\n    padding: 0 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    row-gap: 1.5rem;\n    column-gap: 1rem;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1000px;\n  padding: 0 2rem;\n  margin-top: 20px;\n  margin-bottom: 38px;\n\n  @media screen and (max-width: 766px) {\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #000000;\n  font-weight: 600;\n  margin-bottom: 0.8rem;\n  scroll-margin: 50px 0 0 0;\n\n  @media screen and (min-width: 767px) {\n    font-size: 28px;\n    padding: 0 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 20px;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  border-right: 1px solid #eaeaea;\n  position: sticky;\n  height: 100vh;\n  width: 300px;\n  display: ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    width: 100vw;\n    top: 0px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  all: unset;\n  display: flex;\n  position: absolute;\n  bottom: 0%;\n  height: 48px;\n  width: 100vw;\n  justify-content: center;\n  align-itemns: center;\n  background: white;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  all: unset;\n  display: flex;\n  height: 48px;\n  width: 50vw;\n  justify-content: center;\n  align-items: center;\n  background: white;\n  border: 1px solid #e2e2e2;\n  :last-child {\n    border-left: none;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  all: unset;\n  display: flex;\n  height: 48px;\n  width: 50vw;\n  justify-content: center;\n  align-items: center;\n  background: white;\n  border: 1px solid #e2e2e2;\n  background: ",
        ";\n  color: #fff;\n  :last-child {\n    border-left: none;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
var ref, ref1;




var storeInfo = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().storeReducer.store;
function slideInAnimate() {
    return "\n    animation-name: slide-in;\n    animation-duration: 0.5s;\n    transform : translateX(50px);\n\n    @keyframes slide-in {\n      from {\n          transform : translateX(0px);\n      }\n      to {\n          transform : translateX(50px);\n      }\n    }\n    ";
}
function slideOutAnimate(trasnlationDist) {
    return "\n    animation-name: slide-out;\n    animation-duration: 0.50s;\n\n    @keyframes slide-out {\n      from {\n          transform : translateX(0px);\n      }\n      to {\n         transform : translateX(".concat(trasnlationDist + 58, "px);\n      }\n    }\n    ");
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    displayName: "Container",
    componentId: "sc-175c9e83-0"
})(_templateObject(), function(props) {
    return props.isBuilderMobile ? "4rem 16px 2rem" : "4rem 0 2rem";
});
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    displayName: "Heading",
    componentId: "sc-175c9e83-1"
})(_templateObject1(), function(props) {
    return props.fontColor || "#000000";
});
var Listing = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Listing",
    componentId: "sc-175c9e83-2"
})(_templateObject2());
var PromoSliderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PromoSliderContainer",
    componentId: "sc-175c9e83-3"
})(_templateObject3());
var ListingHeading = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    displayName: "ListingHeading",
    componentId: "sc-175c9e83-4"
})(_templateObject4());
var AdWidgetContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AdWidgetContainer",
    componentId: "sc-175c9e83-5"
})(_templateObject5(), function(props) {
    return props.showFilterDrawer && _utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__/* .IS_MOBILE */ .q$ ? "overflow: hidden" : "overflow: auto";
}, function(props) {
    return props.showFilterDrawer === null ? "" : props.showFilterDrawer ? slideInAnimate() : slideOutAnimate(props.trasnlationDist);
});
var FilterDrawerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FilterDrawerWrapper",
    componentId: "sc-175c9e83-6"
})(_templateObject6(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.showFilterDrawer) ? "unset" : "none";
}, _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .MAX_MOBILE_WIDTH */ .Cf);
var FilterDrawerMobileCtaContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FilterDrawerMobileCtaContainer",
    componentId: "sc-175c9e83-7"
})(_templateObject7());
var FilterDrawerMobileCta = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "FilterDrawerMobileCta",
    componentId: "sc-175c9e83-8"
})(_templateObject8());
var ref2;
var FilterDrawerMobileCtaApply = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "FilterDrawerMobileCtaApply",
    componentId: "sc-175c9e83-9"
})(_templateObject9(), (ref2 = storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) !== null && ref2 !== void 0 ? ref2 : "#222");


/***/ }),

/***/ 77198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AllCategoryItems": function() { return /* reexport */ AllCategoryItems; },
  "CatalogProductItem": function() { return /* reexport */ CatalogItem; },
  "IntersectionComponent": function() { return /* reexport */ IntersectionComponent; },
  "MobileDsAds": function() { return /* reexport */ components_MobileDsAds; },
  "SelectedCategoryItems": function() { return /* reexport */ SelectedCategoryItems; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/utils/index.js
var utils = __webpack_require__(42466);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/IntersectionComponent.js


function IntersectionComponent(props) {
    var callback = function callback(e) {
        var ref;
        var isIntersecting = e === null || e === void 0 ? void 0 : (ref = e[0]) === null || ref === void 0 ? void 0 : ref.isIntersecting;
        props.onIntersection(isIntersecting);
    };
    var ref = (0,react.useRef)(null);
    var intersectionRef = (0,react.useCallback)(function(node) {
        if (!node) return;
        ref.current = node;
        var observer = new IntersectionObserver(callback, {
            root: null,
            threshold: 0.5
        });
        node && observer.observe(node);
    }, []);
    if (!props.show) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: intersectionRef,
        className: "flex justify-center mt4 relative",
        children: props.Component ? /*#__PURE__*/ (0,jsx_runtime.jsx)(props.Component, {
            style: {
                transform: "translateX(-50%)"
            }
        }) : null
    });
}

// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/Hybrid.styles.js
var Hybrid_styles = __webpack_require__(40237);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/index.ts
var ProductListWrapper = __webpack_require__(68464);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/CatalogItem.tsx




var CatalogItem = function(props) {
    var item = props.item, catalog_items = props.catalog_items, onItemsImageClick = props.onItemsImageClick, showATCBtn = props.showATCBtn;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* ListingHeading */.E, {
                id: "listing-".concat(item.id),
                children: item.name || "Available Items"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                productList: catalog_items[item.id],
                oldCardConfigs: {
                    showButton: showATCBtn,
                    onItemClick: onItemsImageClick,
                    noTags: true
                }
            })
        ]
    }, "listing-".concat(item.id));
};

// EXTERNAL MODULE: ./src/components/Common/LoaderIcon/index.js
var LoaderIcon = __webpack_require__(65700);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
// EXTERNAL MODULE: ./src/utils/scrollOnPageLoad.js
var scrollOnPageLoad = __webpack_require__(87243);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/AllCategoryItems.js














var isComponentMounted = false;
var isObserverIntersecting = false;
var timeoutIds = [];
var AllCategoryItems = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var iteratableCategories = props.iteratableCategories, showATCBtn = props.showATCBtn, onItemClick = props.onItemClick, categorySelected = props.categorySelected;
    var store_id = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    }).store_id;
    var ref = (0,react.useState)(false), shouldLoad = ref[0], setStartLoad = ref[1];
    var catalog_items = (0,es/* useSelector */.v9)(function(state) {
        return state.catalogReducer.catalog_items;
    });
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return {
            state: state.catalogReducer.mb5PaginationData.allCategoryComponent,
            singleCategoryState: state.catalogReducer.mb5PaginationData.selectedCategoryComponent
        };
    }), state = ref1.state, singleCategoryState = ref1.singleCategoryState;
    var areAllCategoriesItemsLoaded = (0,react.useMemo)(function() {
        return catalog_items && Object.keys(catalog_items).length === iteratableCategories.length;
    }, [
        catalog_items,
        iteratableCategories
    ]);
    (0,react.useEffect)(function() {
        var scrollConfig = (0,scrollOnPageLoad/* scrollOnPageLoad */.l)();
        if (scrollConfig.toScroll) {
            try {
                var y_scroll = scrollConfig.y_scroll;
                setTimeout(function() {
                    sessionStorage.removeItem(constants/* CLICKED_ITEM_OBJ */.uI);
                    window.scrollTo({
                        top: y_scroll
                    });
                }, 300);
            } catch (err) {
                console.log("timeout time error:", err);
            }
        } else {
            dispatch((0,catalog/* resetCatalogsList */.wL)());
            dispatch((0,catalog/* resetMB5AllSelectedCategoryPaginationConfig */.pj)());
        }
        return function() {
            isComponentMounted = false;
            isObserverIntersecting = false;
        };
    }, []);
    (0,react.useEffect)(function() {
        if (categorySelected === -1 && !areAllCategoriesItemsLoaded) loadProducts();
    }, [
        categorySelected,
        iteratableCategories,
        shouldLoad
    ]);
    var setState = function(argu) {
        return dispatch((0,catalog/* setMB5AllCategoryPaginationConfig */.Rn)(argu));
    };
    var loadProducts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, currentCategory, ref1, status, isNextPage, currentCategoryIndex, updatedPayload, id;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(iteratableCategories === null || iteratableCategories === void 0 ? void 0 : iteratableCategories[state.currentCategoryIndex]) || !store_id) return [
                            2
                        ];
                        currentCategory = iteratableCategories[state.currentCategoryIndex];
                        state.pageNo = ((ref = singleCategoryState[currentCategory.id]) === null || ref === void 0 ? void 0 : ref.pageNo) || state.pageNo;
                        return [
                            4,
                            (0,utils/* getProducts */.X)(currentCategory.id, currentCategory.hasOwnProperty("is_custom_tag") ? 1 : 0, state.pageNo, store_id)
                        ];
                    case 1:
                        ref1 = _state.sent(), status = ref1.status, isNextPage = ref1.isNextPage;
                        dispatch((0,catalog/* setMB5SelectedCategoryPaginationConfig */.IF)((0,_define_property/* default */.Z)({}, currentCategory.id, {
                            pageNo: state.pageNo + 1,
                            isNext: isNextPage
                        })));
                        /** If status is true then load next, else we maintain the current state which will retry the API call
     * with same configs, when again user focuses on observer component
     */ if (!status) return [
                            2
                        ];
                        currentCategoryIndex = !isNextPage ? state.currentCategoryIndex + 1 : state.currentCategoryIndex;
                        updatedPayload = {
                            currentCategoryIndex: currentCategoryIndex,
                            isNextPage: isNextPage,
                            pageNo: !isNextPage ? 1 : state.pageNo + 1,
                            showLoaderComponent: !!(iteratableCategories === null || iteratableCategories === void 0 ? void 0 : iteratableCategories[state.currentCategoryIndex])
                        };
                        setState(updatedPayload);
                        if (!isComponentMounted) isComponentMounted = true;
                        // Trigger next product loads when the observer is still in view
                        if (isObserverIntersecting) {
                            id = setTimeout(triggerProductLoad, 600);
                            timeoutIds.push(id);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function loadProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    var triggerProductLoad = function() {
        return setStartLoad(function(load) {
            return !load;
        });
    };
    var onIntersection = function(isIntersecting) {
        isObserverIntersecting = isIntersecting;
        if (isIntersecting && isComponentMounted) triggerProductLoad();
    };
    var _RenderCategoriesWithItems = function() {
        if (!(iteratableCategories === null || iteratableCategories === void 0 ? void 0 : iteratableCategories.length)) return null;
        return iteratableCategories.map(function(item) {
            var ref;
            return item.hasOwnProperty("is_active") && item.is_active === 0 || !!(catalog_items === null || catalog_items === void 0 ? void 0 : (ref = catalog_items[item.id]) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CatalogItem, {
                item: item,
                catalog_items: catalog_items,
                onItemsImageClick: onItemClick,
                showATCBtn: showATCBtn
            }, item.id.toString());
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            _RenderCategoriesWithItems(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntersectionComponent, {
                show: state.showLoaderComponent,
                onIntersection: onIntersection,
                Component: LoaderIcon/* default */.Z
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.js
var aos = __webpack_require__(2711);
var aos_default = /*#__PURE__*/__webpack_require__.n(aos);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/removeDsAdsRouteLink.js
var removeDsAdsRouteLink = __webpack_require__(95218);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/MiddleBodyMobileReasonModal.js



function MiddleBodyMobileReasonModal(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex f12px pa14px fw6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-section pb14px",
                        children: "You are seeing this Ad because owner of this website is using the free version"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row justify-between items-center pl18px pr18px black-90",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex f12px fw6",
                        children: [
                            "If you own this website ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "then you can remove this."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "f12px",
                        onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "remove-adsection pa12px fw7",
                            children: "Remove this Ad"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var DigitalShowroomAds_MiddleBodyMobileReasonModal = (MiddleBodyMobileReasonModal);

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody6/Hybrid.styles.js
var MiddleBody6_Hybrid_styles = __webpack_require__(43955);
// EXTERNAL MODULE: ./src/assets/svgExports/InfoIcon.js
var InfoIcon = __webpack_require__(67313);
// EXTERNAL MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModalHOC.js + 2 modules
var ReasonModalHOC = __webpack_require__(93992);
// EXTERNAL MODULE: ./src/utils/checkIfThemePreview.js
var checkIfThemePreview = __webpack_require__(15483);
// EXTERNAL MODULE: ./src/components/DesignSystem/NextImage/index.ts + 1 modules
var NextImage = __webpack_require__(27941);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/MobileDsAds.js
















var mobileColumnNumber = 2; // Number of columns in mobile view for grid
var adRepeatGridLinesConstant = 3; // approx repeating ad after how many grid lines are spanned
var EvalIndexMultiplier = mobileColumnNumber * adRepeatGridLinesConstant; // helper constant for calculation
var incomingNewDataPoints = 0; // helper variable for new productIds that will come
function MobileDsAds(props) {
    var toggleMobileAdReasonModal = /**
   * product.id -> reasonModal Toggled
   * @param {*} id - product id to be toggled
   * @param {*} isReasonModalOpen  - Toggle status of ReasonModal
   */ function toggleMobileAdReasonModal(id, isReasonModalOpen) {
        var tempShowAd = (0,_object_spread/* default */.Z)({}, showAdInfo);
        tempShowAd[id] = isReasonModalOpen;
        setShowAdInfo(tempShowAd);
    };
    var initiateShowAdObject = /**
   * maps product-id's to show if reasonModal
   * corresponding to Ad to false initially
   */ function initiateShowAdObject() {
        var tempShowAdObject = {};
        for(var i = 0; i < dataIdForAds.length; i++){
            tempShowAdObject[dataIdForAds[i]] = false;
        }
        setShowAdInfo(tempShowAdObject);
    };
    var setDataIdArray = /**
   * Appends New ProductId in DataIdArray
   * that will come after processing all items inside Category
   * @param {*} item
   * @param {*} remainder
   */ function setDataIdArray(item, remainder) {
        if (incomingNewDataPoints === 0) {
            var evaluatedIndex = 0;
            setDataIdForAds(function(dataIdForAds) {
                var ref;
                return (0,_to_consumable_array/* default */.Z)(dataIdForAds).concat([
                    (ref = catalog_items[item][evaluatedIndex]) === null || ref === void 0 ? void 0 : ref.id, 
                ]);
            });
        } else {
            var _loop = function() {
                var evaluatedIndex = incomingNewDataPoints * EvalIndexMultiplier - 1;
                setDataIdForAds(function(dataIdForAds) {
                    var ref;
                    return (0,_to_consumable_array/* default */.Z)(dataIdForAds).concat([
                        (ref = catalog_items[item][evaluatedIndex - remainder]) === null || ref === void 0 ? void 0 : ref.id, 
                    ]);
                });
                incomingNewDataPoints--;
            };
            while(incomingNewDataPoints)_loop();
        }
    };
    var getMobileDataIdForAds = /**
   * the function Aprroximates place ad after every 3 CSS Grid Row Span
   * sets {array} -> product.id Below which the ads are placed.
   */ function getMobileDataIdForAds() {
        var totalGridRowLines = 0;
        Object.keys(catalog_items).map(function(item) {
            totalGridRowLines += Math.ceil(catalog_items[item].length / mobileColumnNumber);
            if (Math.floor(totalGridRowLines / adRepeatGridLinesConstant) !== 0) {
                var totalLinesInCategory = Math.ceil(catalog_items[item].length / mobileColumnNumber);
                var remainder = catalog_items[item].length % mobileColumnNumber;
                incomingNewDataPoints = Math.floor(totalLinesInCategory / adRepeatGridLinesConstant);
                setDataIdArray(item, remainder);
                totalGridRowLines = 0;
            }
        });
    };
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)({}), showAdInfo = ref3[0], setShowAdInfo = ref3[1];
    var ref4 = (0,react.useState)([]), dataIdForAds = ref4[0], setDataIdForAds = ref4[1];
    var catalog_items = (0,es/* useSelector */.v9)(function(state) {
        return {
            catalog_items: state.catalogReducer.catalog_items
        };
    }).catalog_items;
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var isPreview = (0,checkIfThemePreview/* default */.Z)();
    (0,react.useEffect)(function() {
        aos_default().init();
    }, []);
    (0,react.useEffect)(function() {
        initiateShowAdObject();
    }, [
        dataIdForAds
    ]);
    (0,react.useEffect)(function() {
        setDataIdForAds([]);
        getMobileDataIdForAds();
    }, [
        catalog_items
    ]);
    return !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf && dataIdForAds.includes(props.data.id) && ((ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.non_premium_ad_url_mobile) && !((ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.is_demo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody6_Hybrid_styles/* AdContainer */.g1, {
            "data-aos": "fade-right",
            "data-aos-duration": "1000",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-column digital-showroom__ads pb20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex container-width pb10px",
                        onClick: function() {
                            return toggleMobileAdReasonModal(props.data.id, true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex f12px o-50 mb6px",
                                children: "Why I am seeing this?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml4px f10px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon/* InfoIcon */.s, {
                                    size: 16,
                                    secondaryColor: "#838383"
                                })
                            })
                        ]
                    }),
                    showAdInfo[props.data.id] && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonModalHOC/* default */.Z, {
                        reasonModal: DigitalShowroomAds_MiddleBodyMobileReasonModal,
                        toggleAdReasonModal: function() {
                            return toggleMobileAdReasonModal(props.data.id, false);
                        },
                        className: "middle-body-mobile-reason-modal",
                        ml: -1.15,
                        translateX: 9.5,
                        translateY: -1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex gif-height items-start pointer",
                        onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                            unoptimized: true,
                            src: (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.non_premium_ad_url_mobile,
                            width: 630,
                            height: 187,
                            loading: "lazy",
                            decoding: "async"
                        })
                    })
                ]
            })
        }) : null
    });
}
/* harmony default export */ var components_MobileDsAds = (MobileDsAds);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/DukaanCard/index.js
var DukaanCard = __webpack_require__(28364);
// EXTERNAL MODULE: ./src/components/FlatList/index.js
var FlatList = __webpack_require__(55772);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(74151);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader.tsx
var GlobalCfeLoader = __webpack_require__(79220);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/PromoSlider/index.tsx + 1 modules
var PromoSlider = __webpack_require__(98521);
// EXTERNAL MODULE: ./src/constants/promos.js
var promos = __webpack_require__(10445);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/SelectedCategoryItems.tsx











// import LoaderIcon from '@/components/Common/LoaderIcon';








var SelectedCategoryItems = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref3.widgetContextState.globalStyle;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref4 = (0,react.useState)(false), isProductsLoading = ref4[0], setIsProductsLoading = ref4[1];
    var ref5 = (0,react.useState)(false), canLoadProducts = ref5[0], setCanLoadProducts = ref5[1];
    var ref6 = (0,react.useState)([]), promosData = ref6[0], setPromosData = ref6[1];
    var iteratableCategories = props.iteratableCategories, showATCBtn = props.showATCBtn, onItemClick = props.onItemClick, categorySelected = props.categorySelected, activeCategoryIndex = props.activeCategoryIndex;
    var ref7 = (0,es/* useSelector */.v9)(function(state) {
        var catalogData = state.catalogReducer;
        return {
            catalogData: catalogData,
            commonData: state.commonReducer,
            state: catalogData.mb5PaginationData.selectedCategoryComponent
        };
    }), _catalogData = ref7.catalogData, catalog_items = _catalogData.catalog_items, productTags = _catalogData.productTags, loader = ref7.commonData.loader, state = ref7.state;
    var catID = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) || categorySelected;
    var isTag = productTags.findIndex(function(tag) {
        return tag.id === +catID;
    }) >= 0;
    var selectedPaginationConfig = state[catID];
    var isNextPage = selectedPaginationConfig === null || selectedPaginationConfig === void 0 ? void 0 : selectedPaginationConfig.isNext;
    (0,react.useEffect)(function() {
        var scrollConfig = (0,scrollOnPageLoad/* scrollOnPageLoad */.l)();
        if (scrollConfig.toScroll) {
            try {
                var y_scroll = scrollConfig.y_scroll;
                setTimeout(function() {
                    sessionStorage.removeItem(constants/* CLICKED_ITEM_OBJ */.uI);
                    window.scrollTo({
                        top: y_scroll
                    });
                }, 300);
            } catch (err) {
                console.log("timeout time error:", err);
            }
        } else {
            dispatch((0,catalog/* resetCatalogsList */.wL)(catID));
            setState((0,_define_property/* default */.Z)({}, catID, {
                pageNo: 1,
                isNext: true
            }));
        }
        if (catID >= 0) {
            if (!selectedPaginationConfig) setState((0,_define_property/* default */.Z)({}, catID, {
                pageNo: 1,
                isNext: true
            }));
        }
        setCanLoadProducts(true);
    }, [
        catID,
        iteratableCategories
    ]);
    var setState = function(argu) {
        return dispatch((0,catalog/* setMB5SelectedCategoryPaginationConfig */.IF)(argu));
    };
    var loadProducts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(pageNo) {
            var ref, isListFetched, isNextPage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,utils/* getProducts */.X)(catID, isTag ? 1 : 0, pageNo)
                        ];
                    case 1:
                        ref = _state.sent(), isListFetched = ref.status, isNextPage = ref.isNextPage;
                        return [
                            2,
                            {
                                isListFetched: isListFetched,
                                isNextPage: isNextPage
                            }
                        ];
                }
            });
        });
        return function loadProducts(pageNo) {
            return _ref.apply(this, arguments);
        };
    }();
    var setPageNumber = function(pageNo, isNext) {
        return setState((0,_define_property/* default */.Z)({}, catID, {
            pageNo: pageNo,
            isNext: isNext
        }));
    };
    var getItemName = function(item) {
        return item === null || item === void 0 ? void 0 : item.name;
    };
    var loadMoreData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var nextPageNum, ref, isNext, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        if (!isNextPage || loader) return [
                            2
                        ];
                        setIsProductsLoading(true);
                        nextPageNum = state[catID].pageNo || 1;
                        return [
                            4,
                            loadProducts(nextPageNum)
                        ];
                    case 1:
                        ref = _state.sent(), isNext = ref.isNextPage;
                        nextPageNum += 1;
                        setPageNumber(nextPageNum, isNext);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        err = _state.sent();
                        console.log("Error:  ", err);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsProductsLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function loadMoreData() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!(iteratableCategories === null || iteratableCategories === void 0 ? void 0 : iteratableCategories.length)) {
        return null;
    }
    return canLoadProducts && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* ListingHeading */.E, {
                id: "listing-".concat(categorySelected),
                children: getItemName(iteratableCategories[activeCategoryIndex]) || "Available Items"
            }),
            !!(promosData === null || promosData === void 0 ? void 0 : promosData.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* PromoSliderContainer */.GW, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoSlider/* default */.Z, {
                    setPromosDataToParent: setPromosData,
                    type: isTag ? promos/* PROMO_APPLICABILITY_TYPES.TAG */.d.TAG : promos/* PROMO_APPLICABILITY_TYPES.CATEGORY */.d.CATEGORY,
                    typeId: catID
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatList/* default */.Z, {
                        isLoaderVisible: isProductsLoading,
                        isNext: isNextPage,
                        onScrollEnd: loadMoreData,
                        renderInsideFragment: true,
                        renderList: function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                                productList: catalog_items[categorySelected],
                                oldCardConfigs: {
                                    showButton: showATCBtn,
                                    onItemClick: onItemClick,
                                    noTags: productTags.findIndex(function(tag) {
                                        return tag.id === +categorySelected;
                                    }) !== -1
                                },
                                hideLoaderSkeleton: true
                            });
                        }
                    }),
                    loader && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DukaanCard/* default */.Z, {
                                isLoader: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DukaanCard/* default */.Z, {
                                isLoader: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DukaanCard/* default */.Z, {
                                isLoader: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DukaanCard/* default */.Z, {
                                isLoader: true
                            })
                        ]
                    })
                ]
            }),
            isNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt4 relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                    type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.loaderId) || "ellipsis",
                    color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref2 = globalStyle.appLoader) === null || ref2 === void 0 ? void 0 : ref2.color
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/index.js







/***/ }),

/***/ 42466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ getProducts; }
/* harmony export */ });
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96031);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80344);


var getProducts = function(id, type) {
    var pageNo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, storeId = arguments.length > 3 ? arguments[3] : void 0;
    var staleStoreId = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store.store_id;
    var dispatch = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch;
    var sID = storeId || staleStoreId;
    if (!sID) return;
    return new Promise(function(resolve, reject) {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_1__/* .fetchCatalogItemsByCategoryId */ .Is)({
            store_id: sID,
            category_id: id,
            category_type: type,
            page_no: pageNo
        }, function(status, isNextPage) {
            return status ? resolve({
                status: status,
                isNextPage: isNextPage
            }) : reject(status);
        }));
    });
};


/***/ })

}]);